// AWS Configuration for the frontend
import { Amplify } from 'aws-amplify';

// Get configuration from environment variables
const userPoolId = process.env.REACT_APP_USER_POOL_ID || '';
const userPoolClientId = process.env.REACT_APP_USER_POOL_CLIENT_ID || '';
const identityPoolId = process.env.REACT_APP_IDENTITY_POOL_ID || '';
const region = process.env.REACT_APP_AWS_REGION || 'us-east-1';

// Configure Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId,
      userPoolClientId,
      identityPoolId,
      loginWith: {
        email: true
      }
    }
  }
});

console.log('Amplify configured with:', {
  userPoolId,
  userPoolClientId,
  identityPoolId,
  region,
  apiUrl: process.env.REACT_APP_HTTP_API_URL
});

export default Amplify;